/**
 * Converts entity model to document mapping key
 * BROKER entities use SOCIETY mapping for document generation
 * @param entityModel - The entity model from RelatedEntityType
 * @returns The corresponding mapping key for document mappings
 */
export function getDocumentMappingKey(entityModel: string): string {
  switch (entityModel) {
    case "BROKER":
      return "SOCIETY";
    case "CONSTRUCTION_SITE":
      return "CONSTRUCTION_SITE";
    case "PROPOSITION":
      return "PROPOSITION";
    case "SOCIETY":
      return "SOCIETY";
    case "USER":
      return "USER";
    default:
      return entityModel;
  }
} 
